export default url => url.replace(`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HOST_NAME}`, '')
